import { createORPCClient } from "@orpc/client";
import type { ContractRouterClient } from "@orpc/contract";
import {
  sitePreviewContract,
  type SitePreviewContract,
} from "@typedoc/contracts/site-preview/contract";
import { contractLink, type ContractCallContext } from "../contract-client";

export type SitePreviewClient = ContractRouterClient<SitePreviewContract, ContractCallContext>;

/** The Site Preview API through its contract; each call names its region and token. */
export const sitePreviewClient: SitePreviewClient = createORPCClient(
  contractLink(sitePreviewContract),
);
